import http from '../plugins/http';
class Api {
  // 保存引导页
  saveGuide = (data: unknown) => {
    return http.post('/api/v1/live/save_guide', data);
  };
}
export default new Api();
